/* ============================================================
   MICTLÁN — Selección de variantes obligatoria en la ficha
   (snippets/mx-variante-obligatoria.liquid)
   ============================================================
   Horizon marca de inicio la primera variante disponible. Aquí:
   · al cargar se desmarcan las opciones (salvo que la liga traiga
     ?variant=, o la opción tenga un solo valor, que no es fieldset);
   · cada opción que el cliente toca queda «elegida»;
   · Horizon vuelve a pintar el selector tras cada cambio (morph) y
     marca por su cuenta las opciones que faltan: un MutationObserver
     las vuelve a desmarcar antes de que se vean;
   · «Agregar al carrito» (y la barra fija, que le hace click) no
     agrega mientras falte algo: marca en vino, sube y avisa.
   La compra rápida tiene su propia regla en assets/mx-compra-rapida.js.
   ============================================================ */
(function () {
  'use strict';

  var cfg = window.mxVariantes;
  if (!cfg || !cfg.activa) return;

  var conVariante = new URLSearchParams(window.location.search).has('variant');
  var elegidas = new WeakMap(); // picker → Set de nombres de opción elegidos
  var vigilados = new WeakSet();
  var aplicando = false;

  function esFicha(p) {
    return !p.closest('product-card, quick-add-dialog, swatches-variant-picker-component, #mx-rapida');
  }

  function fieldsets(p) {
    return Array.prototype.slice.call(p.querySelectorAll('fieldset.variant-option'));
  }

  function nombreDe(fs) {
    var i = fs.querySelector('input[data-option-name]');
    return i ? i.dataset.optionName : '';
  }

  /** Texto de la leyenda sin el valor ni los dos puntos: «Tipo de relleno». */
  function etiquetaDe(fs) {
    var l = fs.querySelector('legend');
    if (!l) return nombreDe(fs);
    var t = '';
    l.childNodes.forEach(function (n) { if (n.nodeType === 3) t += n.textContent; });
    return t.replace(/:\s*$/, '').trim().toLowerCase() || nombreDe(fs).toLowerCase();
  }

  function setDe(p) {
    var s = elegidas.get(p);
    if (!s) {
      s = new Set();
      if (conVariante) fieldsets(p).forEach(function (fs) { s.add(nombreDe(fs)); });
      elegidas.set(p, s);
    }
    return s;
  }

  function quitarAttr(el, nombre) { if (el.hasAttribute(nombre)) el.removeAttribute(nombre); }
  function ponerAttr(el, nombre) { if (!el.hasAttribute(nombre)) el.setAttribute(nombre, ''); }

  function avisoDe(p) {
    var a = p.nextElementSibling;
    return a && a.classList.contains('mx-variante-aviso') ? a : null;
  }

  /** Desmarca lo que el cliente no ha elegido. Devuelve los fieldsets que faltan. */
  function aplicar(p) {
    var set = setDe(p);
    var faltan = [];
    aplicando = true;
    fieldsets(p).forEach(function (fs) {
      if (set.has(nombreDe(fs))) {
        quitarAttr(fs, 'data-mx-sin-elegir');
        quitarAttr(fs, 'data-mx-falta');
        return;
      }
      fs.querySelectorAll('input').forEach(function (i) {
        if (i.checked) i.checked = false;
        quitarAttr(i, 'checked');
        if (i.dataset.currentChecked !== 'false') i.dataset.currentChecked = 'false';
        if (i.dataset.previousChecked !== 'false') i.dataset.previousChecked = 'false';
      });
      ponerAttr(fs, 'data-mx-sin-elegir');
      faltan.push(fs);
    });
    ponerAttr(p, 'data-mx-listo');

    var seccion = p.closest('.shopify-section') || p.parentElement;
    if (seccion) {
      if (faltan.length) ponerAttr(seccion, 'data-mx-pendiente');
      else quitarAttr(seccion, 'data-mx-pendiente');
    }

    var aviso = avisoDe(p);
    if (aviso && !aviso.hidden) {
      if (faltan.length) aviso.textContent = textoAviso(faltan);
      else aviso.hidden = true;
    }
    aplicando = false;
    return faltan;
  }

  function textoAviso(faltan) {
    // En el orden en que se ven: el color va al final (blocks/mx-pdp-estilo, order: 2).
    var orden = faltan.filter(function (fs) { return !fs.classList.contains('variant-option--swatches'); })
      .concat(faltan.filter(function (fs) { return fs.classList.contains('variant-option--swatches'); }));
    var nombres = orden.map(etiquetaDe);
    var lista = nombres.length > 1
      ? nombres.slice(0, -1).join(', ') + ' y ' + nombres[nombres.length - 1]
      : nombres[0];
    return String(cfg.aviso || 'Elige [opcion] para continuar').replace(/\[opcion\]/g, lista);
  }

  function avisar(p, faltan) {
    faltan.forEach(function (fs) { ponerAttr(fs, 'data-mx-falta'); });
    var aviso = avisoDe(p);
    if (!aviso) {
      aviso = document.createElement('p');
      aviso.className = 'mx-variante-aviso';
      aviso.setAttribute('role', 'alert');
      p.after(aviso);
    }
    aviso.textContent = textoAviso(faltan);
    aviso.hidden = false;
    // Sin mover el foco: el anillo de foco en una muestra parecería una opción elegida.
    p.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function vigilar(p) {
    if (vigilados.has(p)) return;
    vigilados.add(p);
    aplicar(p);
    new MutationObserver(function () {
      if (!aplicando) aplicar(p);
    }).observe(p, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['checked', 'data-mx-listo', 'data-current-checked'],
    });
  }

  function iniciar() {
    document.querySelectorAll('variant-picker').forEach(function (p) {
      if (esFicha(p)) vigilar(p);
    });
  }

  /** El selector de la ficha que corresponde a un botón o formulario de compra. */
  function pickerDe(el) {
    var seccion = el.closest('.shopify-section');
    if (!seccion) return null;
    var ps = Array.prototype.filter.call(seccion.querySelectorAll('variant-picker'), esFicha);
    return ps[0] || null;
  }

  function bloquearSiFalta(e, el) {
    var p = pickerDe(el);
    if (!p) return;
    vigilar(p);
    var faltan = aplicar(p);
    if (!faltan.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    avisar(p, faltan);
  }

  // El cliente elige: la opción queda como suya (antes de que Horizon pida la variante).
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!(i instanceof HTMLInputElement) || !i.dataset.optionName) return;
    var p = i.closest('variant-picker');
    if (!p || !esFicha(p)) return;
    setDe(p).add(i.dataset.optionName);
    var fs = i.closest('fieldset');
    if (fs) {
      quitarAttr(fs, 'data-mx-sin-elegir');
      quitarAttr(fs, 'data-mx-falta');
    }
  }, true);

  // Fase de captura en window: corre antes que Horizon (on:click, handleSubmit).
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var btn = t.closest('product-form-component button[name="add"], product-form-component .accelerated-checkout-block');
    if (btn) bloquearSiFalta(e, btn);
  }, true);

  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (f instanceof HTMLFormElement && f.closest('product-form-component')) bloquearSiFalta(e, f);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
